import { PRINT_GET_PARAMS, PRINT_GET_PRINT_MODE, PRINT_GET_TABLE_MODE } from './types';

export const getters = {
  [PRINT_GET_PARAMS]: state => {
    return state.printParams;
  },
  [PRINT_GET_PRINT_MODE]: state => {
    return state.printMode;
  },
  [PRINT_GET_TABLE_MODE]: state => {
    return state.tableMode;
  }
};
